import {Component, Input} from '@angular/core';

@Component({
  selector: 'field-float-readonly',
  templateUrl: 'field-float-readonly.component.html',
  styleUrls: ['field-float-readonly.component.scss']
})
export class FieldFloatReadonlyComponent {
  @Input() field: any;

  constructor() {
  }

  ngOnInit() {
  }

  get value() {
    return this.field.value?.data || [];
  }

}
